import styled, { css } from 'styled-components';
import { FocusStyles } from '../../styles/FocusStyles';
import { variables } from '../themes/theme';
export const InputWrapper = styled.div `
  display: inline-block;
  margin-bottom: ${props => props.hasSpaceBelow && '1rem'};
  position: relative;

  > ${props => props.inputSelector} {
    appearance: none;
    background-color: ${variables.White};
    border-radius: 0;
    border-color: ${variables.DirtyWhite};
    border-style: solid;
    border-width: 1px;
    color: ${variables.Gray};
    display: block;
    font-family: ${props => props.theme.fonts.serif};
    font-size: 1rem;
    line-height: 1.38;
    padding: 0.4375rem 0.5625rem;
    width: 100%;

    &::placeholder {
      color: ${variables.LightGray};
      /* Fix multiline placeholder in Safari */
      white-space: nowrap;
    }

    ${(props) => props.isDisabled &&
    css `
        cursor: not-allowed;
        text-overflow: ellipsis;
      `};

    ${(props) => props.isBorderless &&
    css `
        border: none;
      `};

    ${props => props.isInvalid &&
    css `
        border-color: ${props.theme.BrandPrimary};
        border-style: solid;
        border-width: 1px;
      `};

    ${FocusStyles}
  }
`;
